;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import FavoriteButton from 'components/globals/FavoriteButton';

import Img from 'components/ui/Img';
import Link from 'components/ui/Link';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import { formatRecipeTime } from 'utils';

import styles from './CardRecipe.module.scss';

const CardRecipe = ({
    id,
    cardImage,
    cardImageLarge,
    category,
    cookTime,
    prepTime,
    slug,
    title,
}) => {
    cookTime ??= 0;
    prepTime ??= 0;

    return (
        <article className={styles.root}>
            <div className={styles.favoriteButtonContainer}>
                <FavoriteButton itemType={'recipe'} itemId={id} />
            </div>
            <Link href={`/recipes/${slug}`} className={styles.inner}>
                <div className={styles.aspectBox}>
                    {cardImage?.url && (
                        <Img
                            className={styles.image}
                            src={cardImage.url}
                            width={cardImage?.width}
                            height={cardImage?.height}
                            alt={cardImage.description || ''}
                            customSources={[
                                {
                                    breakpoint: 1440,
                                    src: cardImageLarge?.url
                                        ? cardImageLarge.url
                                        : cardImage.url,
                                    imageWidth: 1440 * 0.5,
                                },
                                {
                                    breakpoint: 1024,
                                    src: cardImageLarge?.url
                                        ? cardImageLarge.url
                                        : cardImage.url,
                                    imageWidth: 1024 * 0.5,
                                },
                                {
                                    breakpoint: 768,
                                    src: cardImageLarge?.url
                                        ? cardImageLarge.url
                                        : cardImage.url,
                                    imageWidth: 768 * 0.75,
                                },
                                {
                                    src: cardImage.url,
                                    imageWidth: 768,
                                },
                            ]}
                        />
                    )}
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.categoryWrapper}>
                        <Text
                            className={styles.category}
                            baseTheme="labelMedium"
                        >
                            {category?.title}
                        </Text>
                        <div className={styles.infoLockup}>
                            <SvgIcon className={styles.timeIcon} type="clock" />
                            <Text
                                className={styles.timeLabel}
                                baseTheme="labelMedium"
                            >
                                {formatRecipeTime(prepTime + cookTime)}
                            </Text>
                        </div>
                    </div>
                    <Text
                        className={styles.headline}
                        baseTheme="headingSmall"
                        as="h5"
                    >
                        {title}
                    </Text>
                </div>
            </Link>
        </article>
    );
};

CardRecipe.propTypes = {
    id: PropTypes.string,
    backgroundColor: PropTypes.string,
    cardImage: PropTypes.shape({
        description: PropTypes.string,
        url: PropTypes.string,
    }),
    cardImageLarge: PropTypes.shape({
        url: PropTypes.string,
    }),
    category: PropTypes.shape({
        title: PropTypes.string,
    }),
    cookTime: PropTypes.number,
    prepTime: PropTypes.number,
    slug: PropTypes.string.isRequired,
    textAlignLeft: PropTypes.string,
    title: PropTypes.string,
    theme: PropTypes.string,
};

export default CardRecipe;
